import { Card } from '@/components/ui/card';
import { toast } from 'sonner';
import { Globe, LinkSimple, QrCode, ArrowSquareOut, ImageSquare } from '@phosphor-icons/react';
import { SolucionesPortadaManager } from '@/components/SolucionesPortadaManager';

const A = 'https://customer-assets-lqy194kg.emergentagent.net/job_social-crm-3/artifacts';

const PAGINAS = [
  { slug: '/soluciones', share: 'soluciones', nombre: 'Página Soluciones (Catálogo)', desc: 'Catálogo general: empresa, productos, galería, sedes y contacto.', img: `${A}/04tun9op_c1b49a1c-6b79-4c8f-be77-3442db965c42.jpeg`, destacado: true },
  { slug: '/pasamanosaceroinox', share: 'pasamanos', nombre: 'Pasamanos Acero Inox', desc: 'Landing de pasamanos con vidrio templado.', img: `${A}/if3cot96_7b3bb18e-7ca0-4c92-99d8-49753f92be08.jpeg` },
  { slug: '/ventanasypuertaseuro', share: 'euro', nombre: 'Ventanas y Puertas Euro', desc: 'Landing de aluminio europeo en 6 colores.', img: `${A}/tpb9mi1u_35649dee-9281-44a8-939f-756a49442286.jpeg` },
  { slug: '/fachadasvidriotemplado', share: 'fachadas', nombre: 'Fachadas Vidrio Templado', desc: 'Landing de fachadas 10/12mm con arañas inox.', img: `${A}/2tv4lhog_04936d63-007a-4228-815a-5a06da328a98.jpeg` },
  { slug: '/duchasymamparas', share: 'duchas', nombre: 'Bañeras, Duchas y Mamparas', desc: 'Landing de mamparas corredizas y abatibles.', img: `${A}/2hu6rcej_6245a9c8-1654-45eb-8aa0-c44e265b2b1f.jpeg` },
  { slug: '/techocurvo', share: 'techo', nombre: 'Techo Curvo', desc: 'Landing de techos curvos sin columnas.', img: `${A}/taark5ga_05a00ed9-a6d1-4567-9787-8661a7e2e063.jpeg` },
  { slug: '/pvcpuertasyventanas', share: 'pvc', nombre: 'PVC Puertas y Ventanas', desc: 'Landing de PVC en blanco e imitación madera.', img: `${A}/lkoq46hn_270d70bc-b4d7-4436-aa20-273deb8d2a81.jpeg` },
  { slug: '/aceroinox', share: 'aceroinox', nombre: 'Trabajos de Acero Inox', desc: 'Mamparas, forros de elevadores, mesas y trabajos a la medida.', img: `${A}/rsygp8ts_a514dc3e-6ea5-49aa-bba7-fda2fb191965.jpeg` },
];

export default function LandingPagesHub() {
  const copiar = (p) => {
    const link = `${window.location.origin}/api/landing/share/${p.share}`;
    navigator.clipboard.writeText(link)
      .then(() => toast.success('Link copiado — listo para compartir', { description: link }))
      .catch(() => toast.error('No se pudo copiar'));
  };

  const promo = (p) => {
    const a = document.createElement('a');
    a.href = `/promos/promo_${p.share}.png`;
    a.download = `Promo_${p.share}.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    toast.success('Imagen promocional descargada');
  };

  const qr = (p) => {
    const a = document.createElement('a');
    a.href = `${window.location.origin}/api/landing/qr/${p.share}`;
    a.download = `QR_${p.share}.png`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    toast.success('QR descargado');
  };

  return (
    <div className="space-y-5" data-testid="landing-pages-hub">
      <div>
        <h1 className="text-2xl font-bold flex items-center gap-2"><Globe size={24} className="text-blue-400" /> Landing Pages</h1>
        <p className="text-sm text-[var(--text-muted)]">Accede a la página Soluciones y a las landing pages de productos. Abre, comparte o descarga el QR de cada una.</p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {PAGINAS.map((p) => (
          <Card key={p.slug} className={`overflow-hidden ${p.destacado ? 'border-blue-400/50' : ''}`} data-testid={`lp-card-${p.share}`}>
            <div className="relative">
              <img src={p.img} alt={p.nombre} className="w-full h-36 object-cover" loading="lazy" />
              {p.destacado && <span className="absolute top-2 left-2 bg-blue-500 text-white text-[9px] font-black px-2 py-0.5 rounded uppercase">Página principal</span>}
            </div>
            <div className="p-4">
              <p className="font-bold text-sm">{p.nombre}</p>
              <p className="text-xs text-[var(--text-muted)] mt-1">{p.desc}</p>
              <p className="text-[10px] text-blue-400 font-mono mt-1.5">{p.slug}</p>
              <div className="flex flex-wrap gap-2 mt-3">
                <a href={p.slug} target="_blank" rel="noreferrer" data-testid={`lp-abrir-${p.share}`}
                  className="flex items-center gap-1 text-[11px] font-bold px-3 py-1.5 rounded-full bg-blue-500 hover:bg-blue-400 text-white transition-colors">
                  <ArrowSquareOut size={13} /> Abrir
                </a>
                <button onClick={() => copiar(p)} data-testid={`lp-copiar-${p.share}`}
                  className="flex items-center gap-1 text-[11px] font-bold px-3 py-1.5 rounded-full border border-blue-400/40 text-blue-400 hover:bg-blue-400/10 transition-colors">
                  <LinkSimple size={13} /> Copiar link
                </button>
                <button onClick={() => qr(p)} data-testid={`lp-qr-${p.share}`}
                  className="flex items-center gap-1 text-[11px] font-bold px-3 py-1.5 rounded-full border border-emerald-400/40 text-emerald-400 hover:bg-emerald-400/10 transition-colors">
                  <QrCode size={13} /> QR
                </button>
                {p.share !== 'soluciones' && (
                  <button onClick={() => promo(p)} data-testid={`lp-promo-${p.share}`}
                    className="flex items-center gap-1 text-[11px] font-bold px-3 py-1.5 rounded-full border border-amber-400/40 text-amber-400 hover:bg-amber-400/10 transition-colors">
                    <ImageSquare size={13} /> Promo
                  </button>
                )}
              </div>
            </div>
          </Card>
        ))}
      </div>
      <SolucionesPortadaManager />
    </div>
  );
}
